import { render, staticRenderFns } from "./BannerSmallForm.vue?vue&type=template&id=7447a735&scoped=true&"
import script from "./BannerSmallForm.vue?vue&type=script&lang=js&"
export * from "./BannerSmallForm.vue?vue&type=script&lang=js&"
import style0 from "./BannerSmallForm.vue?vue&type=style&index=0&id=7447a735&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7447a735",
  null
  
)

export default component.exports